<template>
    <div class="flex items-center rounded border border-gray-300 bg-off-white">
        <input
            type="number"
            class="h-[64px] w-full rounded bg-off-white p-0 text-center text-[16px] hide-number-input-arrows focus-outline-only-inside"
            placeholder="1"
            :value="quantity"
            @input="updateQuantity"
            min="1"
            @focus="openKeyboard"
            @blur="closeKeyboard"
        />
        <button
            class="flex size-[64px] min-w-[64px] items-center justify-center bg-off-white focus-outline-only-inside"
            @click="decrementQuantity"
        >
            <minus-icon class="text-gray" />
        </button>
        <div class="h- h-[26px] w-px border border-gray-300"></div>
        <button
            class="flex size-[64px] min-w-[64px] items-center justify-center bg-off-white focus-outline-only-inside"
            @click="incrementQuantity"
        >
            <plus-icon class="text-gray" />
        </button>
    </div>
</template>

<script>
    import MinusIcon from '../../icons/MinusIcon.vue';
    import PlusIcon from '../../icons/PlusIcon.vue';

    import allStores from '../../../stores/all';

    export default {
        mixins: [allStores],

        name: 'QuantityInput',

        components: {
            MinusIcon,
            PlusIcon,
        },

        props: {
            quantity: {
                type: Number,
                required: true,
            },
        },

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },
        },

        methods: {
            updateQuantity(event) {
                this.$emit('updateQuantity', event.target.value);
            },

            incrementQuantity() {
                this.$emit('updateQuantity', this.quantity + 1);
            },

            decrementQuantity() {
                if (this.quantity > 1) {
                    this.$emit('updateQuantity', this.quantity - 1);
                }
            },

            openKeyboard() {
                if (this.isMobile) {
                    this.appStore.toggleKeyboard(true);
                }
            },

            closeKeyboard() {
                if (this.isMobile) {
                    this.appStore.toggleKeyboard(false);
                }
            },
        },

        watch: {
            quantity(newQuantity) {
                this.$emit('updateQuantity', newQuantity);
            },
        },
    };
</script>

<style scoped>
.hide-number-input-arrows::-webkit-inner-spin-button,
.hide-number-input-arrows::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
